import { useEffect } from 'react';
import { useI18n } from '../i18n/useI18n';

export interface TurnNotice {
  id: string;
  kind: 'next' | 'on';
  songTitle?: string;
}

interface Props {
  notice: TurnNotice;
  onDone: (id: string) => void;
}

const KIND_ICON: Record<TurnNotice['kind'], string> = {
  next: '🎤',
  on: '🔥',
};

export default function TurnToast({ notice, onDone }: Props) {
  const { t } = useI18n();

  useEffect(() => {
    // Aviso de vez fica mais tempo que o toast de dueto (5s) — é o momento de
    // o cantor largar o telemóvel e preparar-se.
    const timer = setTimeout(() => onDone(notice.id), 8000);
    return () => clearTimeout(timer);
  }, [notice.id, onDone]);

  return (
    <div className={`duet-toast duet-toast--result duet-toast--turn-${notice.kind}`} role="alert">
      <div className="duet-toast__content">
        <span className="duet-toast__icon" aria-hidden="true">
          {KIND_ICON[notice.kind]}
        </span>
        <div className="duet-toast__info">
          <div className="duet-toast__title">{t(`turn.${notice.kind}.title`)}</div>
          {notice.songTitle && <div className="duet-toast__song">{notice.songTitle}</div>}
          <div className="duet-toast__song">{t(`turn.${notice.kind}.hint`)}</div>
        </div>
      </div>
    </div>
  );
}
